export enum UserTypeEnum {
  INSTRUCTOR,
  STUDENT,
}
